import { bindable } from 'aurelia-framework';

class NotificationButton {
  @bindable show = false;
  @bindable text = '';
  @bindable actions = [];
  @bindable error = false;
  @bindable onAction = () => {};
  open = false;
  callAction(action) {
    this.toggleText();
    this.onAction({ action });
  }
  toggleText() {
    this.open = !this.open;
  }
}

export { NotificationButton };
